import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useIsWorkerBadgesEnabled(): boolean {
  return useCbhFlag(CbhFeatureFlag.WORKER_BADGES, {
    defaultValue: false,
  });
}
